import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class DbInforApi extends DbCenterBaseApi {

    public get ControllerName(): any {
        return 'dbInfor';
    }

    /**
     * 获取全部数据
     */
    public async getListAll() {
        return await this.send({}, 'getListAll', Methods.GET);
    }
    /**
     * 获取全部数据
     */
    public async getListAllByUserId(userId) {
        return await this.send({userId:userId}, 'getListAllByUserId', Methods.GET);
    }

    /**
     * 根据CatalogId 查询数据
     * @param catalogId 
     * @returns 
     */
    public async getDbByCatalogId(catalogId=null) {
        return await this.send({ catalogId }, 'getDbByCatalogId', Methods.GET);
    }

    /**
     * 获取Db Count
     * @param catalogId 
     * @returns 
     */
    public async getDbCountByCatalogId(catalogId) {
        return await this.send({ catalogId }, 'getDbCountByCatalogId', Methods.GET);
    }

    /**
     * 保存DbInfors
     * @param datas 
     * @returns 
     */
    public async dbInforSaveOrUpdate(datas) {
        return await this.send(datas, 'dbInforSaveOrUpdate', Methods.POST);
    }

    /**
     * 获取版本树
     * @param dbId 
     * @param devProd 
     * @returns 
     */
    public async getDbVersionTreeByDbId(dbId, devProd: 'dev' | 'gray' = 'dev') {
        return await this.send({ dbId, devProd }, 'getDbVersionTreeByDbId', Methods.GET);
    }
    
     /**
     * 获取版本树
     * @param dbId 
     * @param devProd 
     * @returns 
     */
      public async getDbVersionSync(dbId, devProd: 'dev' | 'gray' = 'dev') {
        return await this.send({ dbId, devProd }, 'getDbVersionSync', Methods.GET);
    }

    /**
     * exportTableExcel
     * @param dbId 
     * @param devProd 
     * @returns 
     */
    public async exportTableExcel(ids) {
        return await this.download(ids, 'exportTableExcel');
    }

    /**
     * exportTableSql
     * @param dbId 
     * @param devProd 
     * @returns 
     */
    public async exportTableSql(data) {
        return await this.download(data, 'exportTableSql');
    }

    /**
     * 获取所有表
     * @param dbId 
     * @param devProd 
     * @returns 
     */
    public async getDbByDbId(dbId, devProd: 'dev' | 'gray' = 'dev') {
        return await this.send({ dbId, devProd }, 'getDbByDbId', Methods.GET);
    }

    /**
     * 
     * @param datas 
     * @returns 
     */
    public async sumbitDbChange(datas, devProd: 'dev' | 'gray' = 'dev') {
        return await this.send({ dbVersionTreePos: datas, devProd }, "sumbitDbChange", Methods.POST);
    }

    /**
     * 获取合并树
     * @param dbId 
     * @returns 
     */
    public async getDbMergeTreeByDbId(dbId, devProd: "gray" | "prod" = "gray") {
        return await this.send({ dbId, devProd }, 'getDbMergeTreeByDbId', Methods.GET);
    }

    /**
     * 合并提交记录
     * @param dbVersionTreePos 
     * @param mergeTxt 
     * @param devProd 
     * @returns 
     */
    public async mergeDbCommit(dbVersionTreePos, mergeTxt, dbId, devProd: "gray" | "prod" = "gray") {
        return await this.send({ dbVersionTreePos, mergeTxt, dbId, devProd }, 'mergeDbCommit', Methods.POST);
    }

    /**
     * 获取数据库真实名称
     * @param dbId
     * @param devProd
     */
    public async getTrueNameByDbId(dbId, devProd:any='dev') {
        return await this.send({ dbId, devProd }, 'getTrueNameByDbId', Methods.GET);
    }



}